import { Component, Type } from '@angular/core';
import { assign } from 'lodash';
import * as ag from 'ag-grid';
import { GridBaseComponent } from './grid-base.component';

export const GRID_HEIGHT = {
  AUTO: 'auto',
  FULL: 'full'
};

export interface RowDefinition<T> {
  data: T;
}

export interface GridConfig {
  suppressMovableColumns?: boolean;
  context?: any;
  getRowNodeId?: any;
  api?: ag.GridApi;
  defaultColDef?: any;
  getRowClass?: any;
  getRowHeight?: Function;
  rowClassRules?: any;
  getRowStyle?: any;
  rowClass?: any;
  rowHeight?: number;
  headerHeight?: number;
}

export interface ColumnDefinition {
  label?: string;
  property?: string;
  cellClass?: string;
  headerClass?: string;
  columns?: ColumnDefinition[];
  sortable?: boolean;
  type?: string;
  format?: string;
  decimals?: number;
  width?: number;
  height?: number;
  paddingLeft?: string;
  paddingRight?: string;
  template?: string;
  noData?: string;
  comparator?: any;
  cellRenderer?: any;
  cellRendererFramework?: any;
  hidden?: boolean;
  pinned?: boolean;
  clickEventSuppressed?: boolean;
}

interface TableDefinition {
  title?: string;
  selector: string;
  component?: Component;
  height?: string;
  width?: string;
}

interface GridActionDefinition {
  title: string;
  action: string;
}

interface SelectableTableDefinition extends TableDefinition {
  maxItems?: number;
  color?: string;
  actions?: GridActionDefinition[];
}

export interface TableModel {
  body: any[];
  average?: any;
  difference?: any;
}

export interface GridModel<T> {
  data: T[];
  average?: T;
  difference?: T;
}

export const COLUMN_TYPE = {
  CURRENCY: 'currency',
  DATE: 'date',
  PERCENTAGE: 'percentage',
  DECIMAL: 'decimal',
  STRING: 'string',
  THOUSAND: 'thousand',
  NUMBER: 'number',
  PROPERTY_ORDER: 'order'
};

export function Table(metadata: TableDefinition) {
  const component = metadata.component || {};
  assign(component, {
    selector: metadata.selector,
    template: `
<app-table
  [columnDefinitions]="columnDefs"
  [rows]="data"
  [headerHeight]="headerHeight">
</app-table>`
  });

  return Component(component);
}

export function SelectableGrid(metadata: SelectableTableDefinition) {
  const component = metadata.component || {};
  assign(component, {
    selector: metadata.selector,
    template: `
<app-grid
  title="${metadata.title || ''}"
  [columnDefinitions]="columnDefinitions"
  [data]="data"
  [gridOptions]="gridOptions"
  height="${metadata.height || GRID_HEIGHT.AUTO}"
  width="${metadata.width || ''}"
  ></app-grid>`
  });

  return Component(component);
}

export function Grid(metadata: TableDefinition) {
  const component = metadata.component || {};
  assign(component, {
    selector: metadata.selector,
    template: `
<app-grid
  title="${metadata.title || ''}"
  [columnDefinitions]="columnDefinitions"
  [data]="data"
  [gridOptions]="gridOptions"
  height="${metadata.height || GRID_HEIGHT.AUTO}"
  width="${metadata.width || ''}"
  >
</app-grid>`
  });

  return (cls: Type<any>) => {
    if (!component.providers) component.providers = [];
    component.providers.push({ provide: GridBaseComponent, useExisting: cls });
    return Component(component)(cls);
  }
}

function getActions(actions: GridActionDefinition[]): string {
  if (!actions || !actions.length) return '';
  return actions.map(action => `<grid-action title="${action.title}" (invoke)="${action.action}($event)"></grid-action>`)
    .join('\n\t');
}



// WEBPACK FOOTER //
// ./src/app/shared/components/grids/Grids.ts